import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin } from 'lucide-react';

const CITIES = ["Pickering", "Ajax", "Whitby", "Courtice", "Oshawa", "Bowmanville"];

export default function Footer() {
  return (
    <footer className="bg-zinc-900 text-zinc-400 py-16" data-testid="main-footer">
      <div className="px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
          <div className="col-span-2 md:col-span-1">
            <span className="text-xl font-black tracking-tighter text-white">Durham<span className="text-[#002FA7]">Market</span></span>
            <p className="text-sm mt-3 leading-relaxed">Your trusted local marketplace for Durham Region. Buy, sell, and connect with your community.</p>
          </div>
          <div>
            <h3 className="text-sm font-bold text-white uppercase tracking-wider mb-4">Marketplace</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/browse" className="hover:text-white transition-colors">Browse All</Link></li>
              <li><Link to="/browse?category=home_living" className="hover:text-white transition-colors">Home & Living</Link></li>
              <li><Link to="/browse?category=electronics" className="hover:text-white transition-colors">Electronics</Link></li>
              <li><Link to="/browse?category=vehicles" className="hover:text-white transition-colors">Vehicles</Link></li>
              <li><Link to="/browse?category=services" className="hover:text-white transition-colors">Services</Link></li>
              <li><Link to="/browse?category=free_stuff" className="hover:text-white transition-colors">Free Stuff</Link></li>
            </ul>
          </div>
          <div>
            <h3 className="text-sm font-bold text-white uppercase tracking-wider mb-4">Cities</h3>
            <ul className="space-y-2 text-sm">
              {CITIES.map(c => (
                <li key={c}><Link to={`/browse?city=${c}`} className="hover:text-white transition-colors flex items-center gap-1"><MapPin className="w-3 h-3" /> {c}</Link></li>
              ))}
            </ul>
          </div>
          <div>
            <h3 className="text-sm font-bold text-white uppercase tracking-wider mb-4">Support</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/auth?mode=register" className="hover:text-white transition-colors">Create Account</Link></li>
              <li><Link to="/post" className="hover:text-white transition-colors">Post an Ad</Link></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-zinc-800 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-zinc-500">&copy; {new Date().getFullYear()} DurhamMarket. All rights reserved.</p>
          <p className="text-xs text-zinc-500">Serving the Durham Region community</p>
        </div>
      </div>
    </footer>
  );
}
